import $ from 'jquery';
import * as CONST from '../../common/utils/constants';
import Util from '../../common/utils/ui';

class HomeBanner {
    constructor() {
        this.closeBtn = $('.js-home-banner-close');
        this.homeBannerSection = $('.section--home-personalization');
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        function closeHomeBanner() {
            $('.section--home-personalization').remove();
        }

        this.closeBtn.on('click', (e) => {
            closeHomeBanner();
            document.cookie = 'HomeBannerClosed=1';
        });
    }
}

export default HomeBanner;

$(() => {
	const homeBanner = new HomeBanner();
	homeBanner.init();
});